// 接口定义的： 1真   2否
export enum Bool {
  Truly = 1,
  Falsely = 2,
}
